import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Avatar,
    Box,
    CardActions,
    CardHeader,
    Divider,
    Typography,
    styled
} from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

import DialogWrapper from '@libComponents/Dialog';
import { Button } from '@libComponents';
import { setSnack } from 'utilities/redux.actions';
import { exportEmployeePdf } from 'employee/utils/employeePdf';
import ExportOptionsFields, { useExportOptions } from './exportOptions';

const StyledCardAction = styled(CardActions)(({ theme: { spacing } }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: spacing(3),
    paddingBottom: 0
}));

export default function ExportPdf({ row = {} }) {
    const [open, setOpen] = useState(false);
    const [exporting, setExporting] = useState(false);
    const optionsState = useExportOptions();

    const dispatch = useDispatch();
    const { email, fullName } = row;

    const handleClose = () => {
        if (!exporting) setOpen(false);
    };

    const handleExport = () => {
        if (exporting || !optionsState.selectedCount) return;
        setExporting(true);
        // Called synchronously from the click so the new tab isn't blocked.
        exportEmployeePdf({
            email,
            options: optionsState.options,
            onError: (message) => dispatch(setSnack({ message, type: 'error' })),
            onSuccess: () => setOpen(false)
        }).finally(() => setExporting(false));
    };

    return (
        <Box>
            <Button
                variant='outlined'
                sx={{
                    cursor: 'pointer',
                    justifyContent: 'flex-start',
                    width: '100%',
                    pl: 3
                }}
                type='button'
                onClick={() => setOpen(true)}
                size='small'
                color='primary'
                startIcon={<PictureAsPdfOutlinedIcon color='primary' />}
            >
                Export as PDF
            </Button>

            <DialogWrapper
                open={open}
                onClose={handleClose}
                sx={{ textAlign: 'center' }}
            >
                <Typography variant='h6' sx={{ mb: 1 }}>
                    Export Employee Profile
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <CardHeader
                    sx={{ textAlign: 'left', pt: 0, pb: 1 }}
                    avatar={
                        <Avatar
                            aria-label='employee'
                            sx={{
                                bgcolor: (theme) => theme.palette.primary.main
                            }}
                        >
                            {fullName ? fullName[0] : ''}
                        </Avatar>
                    }
                    title={fullName || ''}
                    subheader={email}
                />

                <Box sx={{ textAlign: 'left', px: 2 }}>
                    <ExportOptionsFields state={optionsState} />
                </Box>

                <Divider sx={{ mt: 2 }} />
                <StyledCardAction>
                    <Button
                        onClick={handleClose}
                        color='tertiary'
                        disabled={exporting}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleExport}
                        loading={exporting}
                        disabled={!optionsState.selectedCount}
                    >
                        Export PDF
                    </Button>
                </StyledCardAction>
            </DialogWrapper>
        </Box>
    );
}
